import { RootState } from '@/reducers';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { UnifiedProfileSearchOptionItem } from './UnifiedProfileSearchOptionItem';

type UnifiedProfileSearchOptionsProps = {
  setSearchInput: (value: string) => void;
  setOptionsVisibility: (value: boolean) => void;
};

export const UnifiedProfileSearchOptions: FC<UnifiedProfileSearchOptionsProps> = ({ setSearchInput, setOptionsVisibility }) => {
  const lastSearches = useSelector((state: RootState) => state.unifiedProfiles.lastSearches);

  return (
    <ul className='absolute z-50 mt-2 w-full overflow-hidden rounded-xl border bg-primary-background'>
      {lastSearches?.map((item) => (
        <UnifiedProfileSearchOptionItem key={item} item={item} setSearchInput={setSearchInput} setOptionsVisibility={setOptionsVisibility} />
      ))}
    </ul>
  );
};
